(function () {
	angular
		.module('trackeye')
		.factory('FlexEventService', FlexEventService);

	FlexEventService.$inject = ['AppFactory', 'C4ApiService', 'FlexEvent', 'DeviceService', 'ConfigurationService', 'HttpQueue', 'LanguageService'];

	function FlexEventService(AppFactory, api, FlexEvent, DeviceService, ConfigurationService, HttpQueue, LanguageService) {
		var events = [],
			exports = {},
			grouped = {},
			lang = undefined;

		var device = DeviceService.getSelectedDevice(function(new_device) {
			device = new_device;
			groupEvents(new_device);
		});

		ConfigurationService.findByName('te-account').then(function (resp) {
			lang = resp[0].data.settings.locale;
		});

		function groupEvents(device) {
			if (!device)
				device = DeviceService.getSelectedDevice();

			if (!device.id)
				return;

			events = [];
			grouped = {};
			api.events().get({id: device.id}, function (response) {
				for (var i = 0; i < response.length; i++) {
					var evt = new FlexEvent(response[i], device);

					if (!evt.isEventSupported())
						continue;

					addToGrouped(evt);
					events.push(evt);
				}
			}, angular.noop);
		}

		var eventTypesByServer = [
			{type: 2, name: 'batterylevel', subject: 'BATTERYLEVEL_EVENT_SUBJECT'},
			{type: 67, name: 'lost', subject: 'LOST_EVENT_SUBJET'},
			{type: 63, name: 'lost3d', subject: 'LOST_EVENT_SUBJECT_3D'},
			{type: 73, name: 'nopositions', subject: 'NOPOSITIONS_EVENT_SUBJECT'},
			{type: 94, name: 'unitmoved', subject: 'UNITMOVED_EVENT_SUBJECT'},
			{type: 96, name: 'changecountry', subject: 'CHANGECOUNTRY_EVENT_SUBJECT'},
			{type: 97, name: 'accountexpire', subject: 'ACCOUNTEXPIRE_EVENT_SUBJECT'},
			{type: 98, name: 'balancetoolow', subject: 'BALANCETOOLOW_EVENT_SUBJECT'}
		];

		var eventTypesByDevice = [
			{type: 9, feature: 20, name: 'button1', subject: 'BUTTON1_EVENT_SUBJECT'},
			//{type: 16, feature: 0, name: 'input1', subject: 'INPUT1_EVENT_SUBJECT'},
			{type: 17, feature: 41, name: 'input2', subject: 'INPUT2_EVENT_SUBJECT'},
			{type: 17, feature: 31, name: 'tamper', subject: 'TAMPER_EVENT_SUBJECT'},
			{type: 30, feature: 29, name: 'gsensor', subject: 'GSENSOR_EVENT_SUBJECT'},
			{type: 35, feature: 30, name: 'lightsensor', subject: 'LIGHTSENSOR_EVENT_SUBJECT'},
			{type: 81, feature: 33, name: 'temperature', subject: 'TEMPERATURE_EVENT_SUBJECT'},
			{type: 95, feature: 36, name: 'echotag', subject: 'ECHOTAG_EVENT_SUBJECT'},
			{type: 103, feature: 34, name: 'distance_below', subject: 'DISTANCE_BELOW_EVENT_SUBJECT'},
			{type: 104, feature: 34, name: 'distance_above', subject: 'DISTANCE_BELOW_EVENT_SUBJECT'}
		];

		exports.getGroupedEvents = function () {
			return grouped;
		};

		exports.getEvents = function () {
			return events;
		};

		exports.getServerEventTypes = function () {
			return eventTypesByServer;
		};

		exports.getDeviceEventTypes = function () {
			return eventTypesByDevice;
		};

		exports.getEventByUuid = function (uuid) {
			if (!uuid)
				return undefined;

			for (var i = 0; i < events.length; i++) {
				if (events[i].getUuid() == uuid)
					return events[i];
			}

			return undefined;
		};

		/**
		 *
		 * @param {FlexEvent} event
		 * @param {Device} device
		 * @return {Promise}
		 */
		exports.deleteEvent = function (event, device) {
			return api.eventhandler('DELETE', device, event).then(function () {
				updateTemperatures(event, true)
				for (var i = 0; i < events.length; i++) {
					if (events[i].getUuid() == event.getUuid()) {
						events.splice(i, 1);
					}
				}
				removeFromGrouped(event);
			});
		};

		/**
		 *
		 * @param {FlexEvent} event
		 * @return {Promise}
		 */
		exports.updateEvent = function (event) {
			return api.eventhandler('PUT', event.device, event.toBody());
		};

		/**
		 *
		 * @param {FlexEvent} event
		 * @return {Promise}
		 */
		exports.createEvent = function (event) {
			return api.eventhandler('POST', event.device, event.toBody())
				.then(function (resp) {
					event.uuid = resp.data.message;
					events.push(event);
					updateTemperatures(event)
					addToGrouped(event);
				});
		};

		/**
		 *
		 * @param {Device[]} devices
		 * @param {FlexEvent} event
		 * @param callback
		 * @returns {*}
		 */
		exports.batchCreateEvent = function(devices, event, callback) {
			devices.forEach(function(device) {
				if (!device.hasOwner()) {
					// Only set the locale of the eventhandler, if user does not own the device.
					event.locale = LanguageService.getAppLocaleString();
				}

				// Associate the event with the device.
				event.device = device;

				// This config is copy paste of `api.eventhandler` in C4apiService.js
				HttpQueue.add('batch-create-events', {
					url: api.getLocalUrl('eventhandler'),
					method: 'POST',
					data: {
						device: {
							uuid: device.getUuid(),
							name: device.getName(),
							nodeid: device.getNodeId()
						},
						event: event.toBody()
					}
				}).then(function() {
					if (typeof callback === "function") {
						updateTemperatures(event)
						callback(device);
					}
				});
			});

			return HttpQueue.promise('batch-create-events');
		};

		/**
		 *
		 * @param {FlexEvent} event
		 */
		exports.cloneEvent = function (event) {
			var clone = new FlexEvent(event, undefined, {
				temp_is_degrees: true,
				moved_distance_km: true
			});

			clone.uuid = undefined;
			clone.device = undefined;
			clone.locale = undefined;
			return clone;
		};

		exports.all = function () {
			return events;
		};

		/**
		 * 
		 * @param {FlexEvent} event 
		 */
		function updateTemperatures(event, remove) {
			if (event.getEventType() !== 81)
				return

			if (remove === true) {
				event.device.unsetTemperatureBoundary()
				return
			}

			var minT = event.getMinTemperature(),
					maxT = event.getMaxTemperature();
					
			event.device.setTemperatureBoundary(minT, maxT);
		}
		/**
		 *
		 * @param {FlexEvent} event
		 */
		function addToGrouped(event) {
			var type = event.getEventType();

			if (grouped[type]) {
				grouped[type].events.push(event);
			} else {
				grouped[type] = {
					events: [event],
					name: event.getEventTypeName().name
				}
			}
		}

		function removeFromGrouped(event) {
			var type = event.getEventType();

			if (!grouped[type]) {
				return;
			}

			for (var i = 0; i < grouped[type].events.length; i++) {
				if (grouped[type].events[i].getUuid() == event.getUuid()) {
					grouped[type].events.splice(i, 1);

					if (!grouped[type].events.length) {
						delete grouped[type];
						break;
					}
				}

			}
		}

		return exports;
	}
})();
